<template>
  <div class="search-container" id="vin-keyword-search">
    <div class="search-box">
      <div class="search-input-container" @mouseenter="innerInput" @mouseleave="leaveInput">
        <input
          type="text"
          id="search-id-1"
          class="search-input"
          autocomplete="off"
          placeholder="输入名称、OE、别名、Enter快速查询"
          v-model="keyword"
          @input="inputTxt"
          @focus="showHistoryPanel"
          @keyup.enter="performSearch"
        />
        <div class="btn-box">
          <i
            :class="{ 'el-icon-circle-close': true, 'el-icon-circle-close-show': showClear }"
            id="clearIconId-1"
            @click="crearKeyword"
          ></i>
          <button class="search-btn" @click="performSearch">
            <img :src="searchIconSvg" alt="" />
          </button>
        </div>
      </div>
      <div v-if="historyType" class="history-panel" :class="{ active: isHistoryPanelVisible }">
        <div class="history-header flex flex-row-center flex-between">
          <span class="history-title">搜索历史</span>
          <button class="clear-history" @click="clearAllHistory">清除全部</button>
        </div>
        <ul class="history-list" v-if="searchHistory.length > 0">
          <li
            class="history-item flex flex-row-center"
            v-for="item in searchHistory"
            :key="item.id"
            @click="selectHistory(item)"
          >
            <span class="history-text flex1">{{ item.content }}</span>
            <button class="delete-item" @click.stop="deleteHistoryItem(item.id)">×</button>
          </li>
        </ul>
        <div class="no-history" v-else>暂无搜索历史</div>
      </div>
    </div>
  </div>
</template>
<script>
import searchIconSvg from "@/assets/svg/searchIcon.svg";
import { mapState } from "vuex";
import { getSearchHistory, deleteGoodsHistory, deleteAllGoodsHistory } from "@/api/goods/index.js";
export default {
  data() {
    return {
      showClear: false,
      keyword: "",
      searchHistory: [],
      oldSearchHistory: [],
      isHistoryPanelVisible: false,
      searchResults: [],
      searchIconSvg,
      queryData: {
        keyword: "", // 关键字
        // code: "", // 编码
        // codeMatch: "", // 编码匹配方式: 左匹配left/右匹配right/全匹配full/其他模糊
        // name: "", // 名称
        // nameMatch: "", // 名称匹配方式: 左匹配left/右匹配right/全匹配full/其他模糊
        // vehModel: "", // 车型
        // vehModelMatch: "", // 车型匹配方式: 左匹配left/右匹配right/全匹配full/其他模糊
        // brand: "", // 品牌
        // brandMatch: "", // 品牌匹配方式: 左匹配left/右匹配right/全匹配full/其他模糊
        // productionPlace: "", // 产地
        // productionPlaceMatch: "", // 产地匹配方式: 左匹配left/右匹配right/全匹配full/其他模糊
        // productionCode: "", // 生产码
        // productionCodeMatch: "", // 生产码匹配方式: 左匹配left/右匹配right/全匹配full/其他模糊
        // posCode: "", // 部位码
        // posCodeMatch: "", // 部位码匹配方式: 左匹配left/右匹配right/全匹配full/其他模糊
        // model: "", // 规格
        // modelMatch: "", // 规格匹配方式: 左匹配left/右匹配right/全匹配full/其他模糊
        // // 性质
        // properties: [],
        // // 仓库
        // warehouses: [],
        isPromotion: 0, // 促销: 0全部/1是/2否
        hasStock: true, // 是否只查有货, true是
        isNormalBuy: false, // 是否常购配件，true是
        categoryId: 0, // 配件分类ID，左侧选择的配件分类对应ID
        category: "", // 配件分类名称
        goodsId: 0, // 商品ID，在查询右侧互换件时传当前选择行的ID
        extaCode: "", // 在查询右侧互换件时原样传上来，左边查询时不传
        page: 0, // 页码
        pageSize: 0 // 页宽
      }
    };
  },
  props: {
    needTwoWord: {
      type: Boolean,
      default: false
    },
    /** VIN 查询下关键字历史传 vinKeyword；空则不拉历史 */
    historyType: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState("user", {
      userInfo: state => state.userInfo
    })
  },
  methods: {
    crearKeyword() {
      this.keyword = "";
      this.showClear = false;
      const searchInput = document.getElementById("search-id-1");
      if (searchInput) {
        searchInput.focus();
      }
      this.$emit("clearInput", "");
    },
    inputTxt() {
      if (this.keyword) {
        this.showClear = true;
      } else {
        this.showClear = false;
      }
      if (this.historyType) {
        this.searchHistory = this.keyword
          ? (this.oldSearchHistory || []).filter(e => e.content && e.content.includes(this.keyword))
          : this.oldSearchHistory || [];
        this.isHistoryPanelVisible = this.searchHistory.length > 0;
      }
    },
    leaveInput() {
      this.showClear = false;
    },
    innerInput() {
      if (this.keyword) {
        this.showClear = true;
      } else {
        this.showClear = false;
      }
    },
    advancedQueryData(data) {
      this.queryData = {
        ...data,
        isPromotion: 0, // 促销: 0全部/1是/2否
        hasStock: this.queryData.hasStock, // 是否只查有货, true是
        isNormalBuy: false,
        resetCategory: true
      };
      this.keyword = "";
    },
    // 执行搜索
    performSearch() {
      this.isHistoryPanelVisible = false;
      if (this.keyword.trim().length === 0) {
        this.$emit("searchKeywordChange", "");
        return;
      }
      if (this.needTwoWord && this.keyword.trim().length < 2) {
        this.$message.error("关键字至少两位");
        return;
      }
      this.$emit("searchKeywordChange", this.keyword);
    },
    clearInput() {
      this.keyword = "";
    },
    async getSearchHistoryData() {
      if (!this.historyType) return;
      const res = await getSearchHistory(this.historyType);
      this.oldSearchHistory = res || [];
      if (this.keyword) {
        this.searchHistory = this.oldSearchHistory.filter(e => e.content && e.content.includes(this.keyword));
      } else {
        this.searchHistory = this.oldSearchHistory;
      }
    },
    async showHistoryPanel() {
      if (!this.historyType || !(this.userInfo && this.userInfo.userId)) return;
      await this.getSearchHistoryData();
      this.isHistoryPanelVisible = this.searchHistory.length > 0;
    },
    // 搜索框展示文案；查件只传 historyId/historyType，不传 keyword
    selectHistory(item) {
      this.keyword = item.content;
      this.isHistoryPanelVisible = false;
      this.$emit("searchKeywordChange", {
        keyword: item.content,
        historyId: item.id,
        historyType: item.type || this.historyType
      });
    },
    deleteHistoryItem(id) {
      this.$confirm("确定删除此条历史记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(async () => {
          await deleteGoodsHistory(id);
          await this.getSearchHistoryData();
          this.$message({ type: "success", message: "删除成功!" });
          if (!this.searchHistory.length) this.isHistoryPanelVisible = false;
        })
        .catch(() => {});
    },
    clearAllHistory() {
      this.$confirm("确定删除所有历史记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(async () => {
          await deleteAllGoodsHistory(this.historyType);
          await this.getSearchHistoryData();
          this.isHistoryPanelVisible = false;
          this.$message({ type: "success", message: "删除成功!" });
        })
        .catch(() => {});
    },
    handleHistoryOutsideClick(e) {
      if (!this.historyType) return;
      const root = document.getElementById("vin-keyword-search");
      if (root && !root.contains(e.target)) {
        this.isHistoryPanelVisible = false;
      }
    }
  },
  mounted() {
    this.$bus.$on("clearCommonSearch", () => {
      this.clearInput();
    });
    if (this.historyType) {
      document.addEventListener("click", this.handleHistoryOutsideClick);
    }
  },
  beforeDestroy() {
    if (this.historyType) {
      document.removeEventListener("click", this.handleHistoryOutsideClick);
    }
  }
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  // font-family: "Segoe UI", "Microsoft YaHei", sans-serif;
}
.el-icon-circle-close {
  color: #999;
  font-size: 22px;
  transition: all 0.3s ease;
  opacity: 0;
  &:hover {
    color: var(--color-primary);
    cursor: pointer;
  }
}
.el-icon-circle-close-show {
  opacity: 1;
}
.search-container {
  width: 100%;
  border-radius: 12px;
  // box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.search-box {
  position: relative;
}

.search-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.search-input {
  width: 100%;
  padding: 12px 80px 12px 15px;
  border: 2px solid var(--color-primary);
  border-radius: 2px;
  font-size: 16px;
  outline: none;
  // transition: border-color 0.3s;
}
.btn-box {
  position: absolute;
  display: flex;
  align-items: center;
  column-gap: 8px;
  right: 5px;
}
.search-input:focus {
  border-color: var(--color-primary);
}

.search-btn {
  background: var(--color-primary);
  height: 39px;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  transition: background 0.3s;
  font-size: 16px;
  font-weight: 500;
}

.search-btn:hover {
  background: var(--color-primary-dark10);
}
.history-panel {
  width: 100%;
  background-color: #fff;
  z-index: 1000;
  position: absolute;
  left: 0;
  top: 100%;
  margin-top: 8px;
  border: 1px solid #e1e5ee;
  border-radius: 8px;
  overflow: hidden;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  display: none;
}
.history-panel.active {
  display: block;
}
.history-header {
  padding: 10px 15px;
  background: #f8f9fa;
  border-bottom: 1px solid #e1e5ee;
}
.history-title {
  font-weight: 600;
  color: #555;
}
.clear-history {
  background: none;
  border: none;
  color: #ff6b6b;
  cursor: pointer;
  font-size: 14px;
}
.history-list {
  list-style: none;
}
.history-item {
  padding: 10px 15px;
  border-bottom: 1px solid #f1f1f1;
  cursor: pointer;
}
.history-item:hover {
  background: #f8f9fa;
}
.history-text {
  color: #333;
}
.delete-item {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 5px;
}
.no-history {
  padding: 16px 15px;
  color: #999;
  text-align: center;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.search-results {
  margin-top: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  display: none;
}

.search-results.active {
  display: block;
  animation: fadeIn 0.3s;
}

.results-title {
  font-weight: 600;
  margin-bottom: 10px;
  color: #555;
}

.result-item {
  padding: 8px 0;
  border-bottom: 1px solid #e1e5ee;
}

.result-item:last-child {
  border-bottom: none;
}
</style>
